<div class="hint-card">
  <button class="hint-card__close" type="button" (click)="closed.emit()" aria-label="Close hint">
    <svg width="8" height="8" viewBox="0 0 14 14" fill="none">
      <path
        d="M1 1L13 13M13 1L1 13"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round" />
    </svg>
  </button>

  @if (iconName) {
    <div class="hint-card__icon" aria-hidden="true">
      <svg [attr.width]="iconWidth" [attr.height]="iconHeight">
        <use [attr.xlink:href]="'#' + iconName"></use>
      </svg>
    </div>
  }

  <span class="hint-card__title">{{ titleKey | translate }}</span>

  <p class="hint-card__body">{{ currentText }}</p>

  @if (showPagination) {
    <div class="hint-card__pagination">
      <button
        type="button"
        [disabled]="currentPage === 0"
        (click)="prevPage()"
        aria-label="Previous page">
        &#8249;
      </button>
      <span class="hint-card__counter">{{ currentPage + 1 }} / {{ totalPages }}</span>
      <button
        type="button"
        [disabled]="currentPage === totalPages - 1"
        (click)="nextPage()"
        aria-label="Next page">
        &#8250;
      </button>
    </div>
  }
</div>
